import { createContext, useContext } from 'react';
import { SidebarState, SidebarContextProps } from '../types';

export const SidebarContext = createContext<SidebarContextProps | null>(null);

export const useNavMenuSidebar = (skipContext = false) => {
  const context = useContext(SidebarContext);
  if (!context && !skipContext) {
    throw new Error('useSidebar must be used within a SidebarProvider.');
  }

  const sidebarState = context?.sidebars ?? { isOpen: false, isMobileOpen: false };

  return {
    ...sidebarState,
    isMobile: context?.isMobile ?? false,
    toggleSidebar: () => context?.toggleSidebar(),
    setSidebarState: (state: Partial<SidebarState>) => context?.setSidebarState(state)
  };
};
